import axios, { AxiosRequestConfig } from "axios";
import config from "config";

import { api } from "config/urls";

import { formatUrl } from "utils";

type ValidateOtpRequest = {
  otp: string;
};

type ValidateOtpResponse = {
  accessToken: string;
};

export interface PublicApiService {
  validateOtp: (
    { otp }: ValidateOtpRequest,
    options?: AxiosRequestConfig
  ) => Promise<ValidateOtpResponse>;
}

export const axiosInstance = axios.create({
  headers: { "Content-Type": "application/json;charset=UTF-8" },
  baseURL: config.PUBLIC_API_URL,
});

export const makePublicApiService = (): PublicApiService => {
  const validateOtp: PublicApiService["validateOtp"] = ({ otp }, options) => {
    return axiosInstance
      .get(formatUrl(api.validateOtp, { otp }), options)
      .then((d) => d.data);
  };

  return {
    validateOtp,
  };
};
